import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { getAuthUser } from 'store/auth/selectors';
import { clearGenTaxCalledPage } from 'utils/check-page-loaded';

export const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  const loggedUser = useSelector(getAuthUser);

  React.useEffect(() => {
    if (loggedUser) window.location.replace('/login');
    else {
      clearGenTaxCalledPage();
      window.location.replace('/main');
    }
  }, [loggedUser]);

  return (
    <React.Fragment>
      <Helmet>
        <title>{`${t('other.not-found-page')} | ${process.env.PROJECT_NAME}`}</title>
        <meta name="description" content={t('other.not-found-page-description')} />
      </Helmet>

      {/* <div className="page-404 px-4 p-md-0">Not Found Page</div> */}
    </React.Fragment>
  );
};
